// extracted by mini-css-extract-plugin
export default {"container":"vxVRbcvqcEsuFwvQTukA9A==","title":"Zk1lMl5HOl-vAtT9zmCP8Q==","list":"AXqi5eV9yKSYFifSD3jsBA==","list-item":"FOPdCPfNQrJN-YLy8nYtRg==","image":"_3pVuEsRDi18xHSGzJEI2tw=="};